export default __webpack_public_path__ + "static/media/home.23ef8317.svg";